import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import ConfirmAccount from "../components/ConfirmAccount";
// import ResetPassword from "../components/ResetPassword";
import Layout from '../components/common/Layout';
import ChangePassword from '../components/ChangePassword.vue';
import MapView from "@/components/MapView";
import Dashboard from "@/components/Dashboard";
import Site from "@/components/Site";
import Group from "@/components/Group";
import Detail from "@/components/Detail";
import EditMember from "@/components/dialog/group/EditMember";
import AddGroup from "@/components/dialog/group/AddGroup";
import EditGroup from "@/components/dialog/group/EditGroup";
import Report from "@/components/Report";
import ReportPrint from "@/components/ReportPrint";
import ResetPassword from "@/components/ResetPassword";
import ProfileEdit from "@/components/ProfileEdit";
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/report/download',
    name: 'ReportPrint',
    component: ReportPrint
  },

  {
    path: '/',
    redirect: '/dashboard',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: '/map/:folderUuid',
        name: 'MapView',
        component: MapView
      },
      {
        path: '/changepass',
        name: 'ChangePassword',
        component: ChangePassword
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: '/site/:id',
        name: 'Site',
        component: Site
      },
      {
        path: '/group',
        name: 'Group',
        component: Group,
      },
      {
        path: '/group/add',
        name: 'AddGroup',
        component: AddGroup
      },
      {
        path: '/group/:groupId',
        name: 'Detail',
        component: Detail
      },
      {
        path: '/group/:groupId/edit',
        name: 'EditGroup',
        component: EditGroup
      },

      {
        path: '/group/:groupId/editmember',
        name: 'EditMember',
        component: EditMember
      },
      {
        path: '/report/:folderUuid',
        name: 'Report',
        component: Report
      },
      {
        path: '/profile/edit',
        name: 'ProfileEdit',
        component: ProfileEdit
      }
    ],
  },

  {
    path: '/account/confirm/:uid/:token',
    component: ConfirmAccount,
  },
  {
    path: '/password/reset/confirm/:uid/:token',
    component: ResetPassword,
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    '/login',
    '/register',

  ];
  const authRequired = !(publicPages.includes(to.path));
  const loggedIn = localStorage.getItem('drs_user');
  if (authRequired && !loggedIn && !to.path.match(/account.*/) && !to.path.match(/password.*/)) {
    return next({
      path: '/login',
      query: { nextUrl: to.path },
  })
  }
  next();
})

export default router
